import { EditorState } from "draft-js";
import { ATUALIZAR_EDITOR, LIMPAR_EDITOR } from "./actions";

const initialState = {
  editores: { "padrao": EditorState.createEmpty() }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ATUALIZAR_EDITOR:
      return { ...state, editores: { ...state.editores, [action.chave]: action.editorState } };
    case LIMPAR_EDITOR:
      return { ...state, editores: { ...state.editores, [action.chave]: EditorState.createEmpty() } };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/componentes/editor/reducers.js